<template>
  <div>
    <admin-navbar />
    <div class="view-page">
      <router-view />
    </div>
  </div>
</template>

<script>
import AdminNavbar from '@/components/AdminNavbar'

export default {
  components: {
    AdminNavbar
  }
}
</script>
